
// // client/src/components/PlatformSelector.jsx
// // ========================================================================
// // IMPROVED VERSION - Better height handling and visibility
// // EMOJIS REMOVED FROM DISPLAY
// // ========================================================================

// import React, { useState, useRef, useEffect } from 'react';

// /**
//  * Platform configuration with emoji icons
//  * (Emojis kept in data structure but not displayed in UI)
//  */
// const PLATFORMS = [
//   { 
//     key: 'instagram', 
//     label: 'Instagram', 
//     emoji: '📷',
//     color: '#E4405F',
//     description: 'Share photos and reels'
//   },
//   { 
//     key: 'facebook', 
//     label: 'Facebook', 
//     emoji: '📘',
//     color: '#1877F2',
//     description: 'Post to Facebook pages'
//   },
//   { 
//     key: 'twitter', 
//     label: 'Twitter', 
//     emoji: '🐦',
//     color: '#1DA1F2',
//     description: 'Tweet with media'
//   },
//   { 
//     key: 'linkedin', 
//     label: 'LinkedIn', 
//     emoji: '💼',
//     color: '#0A66C2',
//     description: 'Professional networking'
//   } ,
//  { 
//      key: 'bluesky', 
//      label: 'Bluesky', 
//      emoji: '🦋',
//      color: '#0085FF',
//      description: 'Decentralized social'
//   },
//   // { 
//   //   key: 'youtube', 
//   //   label: 'YouTube', 
//   //   emoji: '▶️',
//   //   color: '#FF0000',
//   //   description: 'Upload videos'
//   // },
//   { 
//     key: 'tiktok', 
//     label: 'TikTok', 
//     emoji: '🎵',
//     color: '#000000',
//     description: 'Short-form video'
//   }
// ];

// /**
//  * PlatformSelector Component
//  */
// export default function PlatformSelector({ 
//   platforms, 
//   setPlatforms, 
//   onConnect,
//   showConnectFor = [],
//   style = {},
//   className = ''
// }) {
//   const [isOpen, setIsOpen] = useState(false);
//   const dropdownRef = useRef(null);

//   // Count selected platforms
//   const selectedCount = Object.values(platforms).filter(Boolean).length;
//   const selectedPlatforms = PLATFORMS.filter(p => platforms[p.key]);

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsOpen(false);
//       }
//     };

//     if (isOpen) {
//       document.addEventListener('mousedown', handleClickOutside);
//     }

//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, [isOpen]);

//   const togglePlatform = (key) => {
//     setPlatforms(prev => ({ ...prev, [key]: !prev[key] }));
//   };

//   const handleConnect = (platformKey) => {
//     if (onConnect) {
//       onConnect(platformKey);
//     }
//   };

//   return (
//     <div className={`platform-selector ${className}`} style={style}>
//       {/* Dropdown Button */}
//       <div 
//         ref={dropdownRef}
//         className="relative"
//         style={{ width: '100%' }}
//       >
//         <button
//           type="button"
//           className="btn btn-outline-primary w-full flex items-center justify-between"
//           onClick={() => setIsOpen(!isOpen)}
//           style={{ 
//             padding: '14px 16px',
//             fontSize: '15px',
//             fontWeight: 500
//           }}
//         >
//           <div className="flex items-center gap-2">
//             <span>Select Platforms</span>
//             {selectedCount > 0 && (
//               <span 
//                 className="badge bg-cobalt rounded-full"
//                 style={{ fontSize: '12px' }}
//               >
//                 {selectedCount}
//               </span>
//             )}
//           </div>
//           <span style={{ 
//             transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
//             transition: 'transform 0.2s',
//             fontSize: '14px',
//             fontWeight: 'bold'
//           }}>
//             ▼
//           </span>
//         </button>

//         {/* Dropdown Menu */}
//         {isOpen && (
//           <div 
//             className="absolute w-full mt-2"
//             style={{ 
//               zIndex: 1050,
//               left: 0,
//               right: 0
//             }}
//           >
//             <div
//               className="card shadow-lg"
//               style={{
//                 border: '1px solid #dee2e6',
//                 borderRadius: '8px',
//                 maxHeight: '450px',
//                 minHeight: '320px',
//                 height: 'auto',
//                 overflowY: 'auto',
//                 overflowX: 'hidden'
//               }}
//             >
//               <div className="list-group list-group-flush">
//                 {PLATFORMS.map((platform, index) => {
//                   const isSelected = platforms[platform.key];
//                   const isLast = index === PLATFORMS.length - 1;

//                   return (
//                     <div
//                       key={platform.key}
//                       className={`list-group-item ${!isLast ? 'border-bottom' : ''}`}
//                       style={{
//                         cursor: 'pointer',
//                         transition: 'background-color 0.15s',
//                         backgroundColor: isSelected ? '#f8f9fa' : 'transparent',
//                         padding: '16px 20px',
//                         minHeight: '70px'
//                       }}
//                       onMouseEnter={(e) => {
//                         if (!isSelected) {
//                           e.currentTarget.style.backgroundColor = '#f8f9fa';
//                         }
//                       }}
//                       onMouseLeave={(e) => {
//                         if (!isSelected) {
//                           e.currentTarget.style.backgroundColor = 'transparent';
//                         }
//                       }}
//                     >
//                       <div className="flex items-center justify-between">
//                         {/* Checkbox + Label (emoji removed from display) */}
//                         <div 
//                           className="flex items-center gap-3 flex-grow"
//                           onClick={() => togglePlatform(platform.key)}
//                           style={{ minHeight: '40px' }}
//                         >
//                           <input
//                             type="checkbox"
//                             className="form-check-input m-0"
//                             checked={isSelected}
//                             onChange={() => {}} // Handled by parent div click
//                             style={{ 
//                               width: '22px', 
//                               height: '22px',
//                               cursor: 'pointer',
//                               flexShrink: 0
//                             }}
//                           />
//                           {/* Emoji removed - no longer displayed */}
//                           <div className="flex-grow">
//                             <div 
//                               className="font-semibold flex items-center"
//                               style={{ fontSize: '15px', marginBottom: '2px' }}
//                             >
//                               {platform.label}
//                               {isSelected && (
//                                 <span className="ml-2 text-green-600" style={{ fontSize: '16px' }}>
//                                   ✓
//                                 </span>
//                               )}
//                             </div>
//                             <div 
//                               className="text-gray-400"
//                               style={{ fontSize: '12px' }}
//                             >
//                               {platform.description}
//                             </div>
//                           </div>
//                         </div>

//                         {/* Optional Connect Button */}
//                         {showConnectFor.includes(platform.key) && (
//                           <button
//                             type="button"
//                             className="btn btn-sm btn-outline-secondary"
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               handleConnect(platform.key);
//                             }}
//                             style={{ 
//                               fontSize: '12px',
//                               padding: '4px 12px',
//                               flexShrink: 0
//                             }}
//                           >
//                             Connect
//                           </button>
//                         )}
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Selected Platforms Chips (emoji removed from display) */}
//       {selectedCount > 0 && (
//         <div className="mt-3 flex flex-wrap gap-2">
//           {selectedPlatforms.map((platform) => {
//             return (
//               <div
//                 key={platform.key}
//                 className="badge flex items-center gap-2"
//                 style={{
//                   backgroundColor: '#f8f9fa',
//                   color: '#212529',
//                   border: '1px solid #dee2e6',
//                   padding: '8px 14px',
//                   fontSize: '14px',
//                   fontWeight: 500,
//                   borderRadius: '20px'
//                 }}
//               >
//                 {/* Emoji removed - no longer displayed */}
//                 {platform.label}
//                 <button
//                   type="button"
//                   className="btn-close"
//                   style={{ 
//                     fontSize: '10px',
//                     padding: 0,
//                     width: '14px',
//                     height: '14px'
//                   }}
//                   onClick={() => togglePlatform(platform.key)}
//                   aria-label={`Remove ${platform.label}`}
//                 />
//               </div>
//             );
//           })}
//         </div>
//       )}

//       {/* Helper Text */}
//       {selectedCount === 0 && (
//         <div className="text-gray-400 small mt-2" style={{ fontSize: '13px' }}>
//           Click the button above to select where you want to post
//         </div>
//       )}
//     </div>
//   );
// }

// // ========================================================================
// // COMPACT INLINE VARIANT (emoji removed from display)
// // ========================================================================

// export function PlatformSelectorCompact({ 
//   platforms, 
//   setPlatforms,
//   showLabels = false 
// }) {
//   const selectedCount = Object.values(platforms).filter(Boolean).length;

//   return (
//     <div className="flex flex-wrap gap-2">
//       {PLATFORMS.map((platform) => {
//         const isSelected = platforms[platform.key];

//         return (
//           <button
//             key={platform.key}
//             type="button"
//             className={`btn ${isSelected ? 'btn-primary' : 'btn-outline-secondary'} flex items-center gap-2`}
//             onClick={() => setPlatforms(prev => ({ ...prev, [platform.key]: !prev[platform.key] }))}
//             title={platform.label}
//             style={{
//               padding: showLabels ? '8px 14px' : '8px 10px',
//               fontSize: '14px'
//             }}
//           >
//             {/* Emoji removed - no longer displayed */}
//             <span>{platform.label}</span>
//           </button>
//         );
//       })}
      
//       {selectedCount > 0 && (
//         <div 
//           className="badge bg-gray-600 flex items-center"
//           style={{ padding: '10px 12px', fontSize: '13px' }}
//         >
//           {selectedCount} selected
//         </div>
//       )}
//     </div>
//   );
// }


// client/src/components/PlatformSelector.jsx
// ========================================================================
// IMPROVED VERSION - Better height handling and visibility
// EMOJIS REMOVED FROM DISPLAY
// CONNECT BUTTON REMOVED
// ========================================================================

import React, { useState, useRef, useEffect } from 'react';

/**
 * Platform configuration with emoji icons
 * (Emojis kept in data structure but not displayed in UI)
 */
const PLATFORMS = [
  {
    key: 'instagram',
    label: 'Instagram',
    emoji: '📷',
    color: '#E4405F',
    description: 'Share photos and reels'
  },
  {
    key: 'facebook',
    label: 'Facebook',
    emoji: '📘',
    color: '#1877F2',
    description: 'Post to Facebook pages'
  },
  {
    key: 'twitter',
    label: 'Twitter',
    emoji: '🐦',
    color: '#1DA1F2',
    description: 'Tweet with media'
  },
  {
    key: 'linkedin',
    label: 'LinkedIn',
    emoji: '💼',
    color: '#0A66C2',
    description: 'Professional networking'
  },
  {
    key: 'bluesky',
    label: 'Bluesky',
    emoji: '🦋',
    color: '#0085FF',
    description: 'Decentralized social'
  },
  {
    key: 'threads',
    label: 'Threads',
    emoji: '🧵',
    color: '#000000',
    description: 'Text-based conversations'
  },
  {
    key: 'youtube',
    label: 'YouTube',
    emoji: '▶️',
    color: '#FF0000',
    description: 'Upload videos'
  },
  {
    key: 'tiktok',
    label: 'TikTok',
    emoji: '🎵',
    color: '#000000',
    description: 'Short-form video'
  },
  // {
  //   key: 'wechat',
  //   label: 'WeChat',
  //   emoji: '💬',
  //   color: '#07C160',
  //   description: 'Super app for messaging and social'
  // },
  // {
  //   key: 'snapchat',
  //   label: 'Snapchat',
  //   emoji: '👻',
  //   color: '#FFFC00',
  //   description: 'Photos and AR filters'
  // },
  // {
  //   key: 'reddit',
  //   label: 'Reddit',
  //   emoji: '🤖',
  //   color: '#FF4500',
  //   description: 'Post to Reddit communities'
  // },
  {
    key: 'pinterest',
    label: 'Pinterest',
    emoji: '📌',
    color: '#E60023',
    description: 'Visual discovery and ideas'
  },
  // {
  //   key: 'quora',
  //   label: 'Quora',
  //   emoji: '❓',
  //   color: '#B92B27',
  //   description: 'Knowledge sharing Q&A'
  // },
  // {
  //   key: 'line',
  //   label: 'Line',
  //   emoji: '💚',
  //   color: '#00B900',
  //   description: 'Messaging and social features'
  // },
  // {
  //   key: 'twitch',
  //   label: 'Twitch',
  //   emoji: '🎮',
  //   color: '#9146FF',
  //   description: 'Live streaming platform'
  // },
  // {
  //   key: 'discord',
  //   label: 'Discord',
  //   emoji: '🎧',
  //   color: '#5865F2',
  //   description: 'Community chat and voice'
  // }
];

/**
 * PlatformSelector Component
 */
export default function PlatformSelector({ 
  platforms, 
  setPlatforms, 
  style = {},
  className = ''
}) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Count selected platforms
  const selectedCount = Object.values(platforms).filter(Boolean).length;
  const selectedPlatforms = PLATFORMS.filter(p => platforms[p.key]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const togglePlatform = (key) => {
    setPlatforms(prev => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div className={`platform-selector ${className}`} style={style}>
      {/* Dropdown Button */}
      <div 
        ref={dropdownRef}
        className="relative"
        style={{ width: '100%' }}
      >
        <button
          type="button"
          className="btn btn-outline-primary w-full flex items-center justify-between"
          onClick={() => setIsOpen(!isOpen)}
          style={{ 
            padding: '14px 16px',
            fontSize: '15px',
            fontWeight: 500
          }}
        >
          <div className="flex items-center gap-2">
            <span>Select Platforms</span>
            {selectedCount > 0 && (
              <span 
                className="badge bg-cobalt rounded-full"
                style={{ fontSize: '12px' }}
              >
                {selectedCount}
              </span>
            )}
          </div>
          <span style={{
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s',
            fontSize: '14px',
            fontWeight: 'bold',
            marginLeft: '1.5em'  // two extra spaces between the trailing "S" and the chevron
          }}>
            ▼
          </span>
        </button>

        {/* Dropdown Menu */}
        {isOpen && (
          <div
            className="absolute w-full mt-2"
            style={{
              zIndex: 1050,
              left: 0,
              right: 0
            }}
          >
            <div
              className="card shadow-lg"
              style={{
                border: '1px solid #dee2e6',
                borderRadius: '8px',
                maxHeight: '450px',
                minHeight: '320px',
                height: 'auto',
                overflowY: 'auto',
                overflowX: 'hidden'
              }}
            >
              <div className="list-group list-group-flush">
                {PLATFORMS.map((platform, index) => {
                  const isSelected = platforms[platform.key];
                  const isLast = index === PLATFORMS.length - 1;

                  return (
                    <div
                      key={platform.key}
                      className={`list-group-item ${!isLast ? 'border-bottom' : ''}`}
                      style={{
                        cursor: 'pointer',
                        transition: 'box-shadow 0.15s, background-color 0.15s',
                        backgroundColor: 'transparent',
                        padding: '16px 20px',
                        minHeight: '70px',
                        boxShadow: isSelected
                          ? 'inset 0 0 0 2px #3b82f6, 0 0 12px 2px rgba(59, 130, 246, 0.6)'
                          : 'none',
                        borderRadius: isSelected ? '6px' : '0',
                        position: 'relative',
                        zIndex: isSelected ? 1 : 0
                      }}
                      onMouseEnter={(e) => {
                        if (!isSelected) {
                          e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!isSelected) {
                          e.currentTarget.style.backgroundColor = 'transparent';
                        }
                      }}
                    >
                      {/* Checkbox + Label (emoji removed from display) */}
                      <div 
                        className="flex items-center gap-3 flex-grow"
                        onClick={() => togglePlatform(platform.key)}
                        style={{ minHeight: '40px' }}
                      >
                        <input
                          type="checkbox"
                          className="form-check-input m-0"
                          checked={isSelected}
                          onChange={() => {}} // Handled by parent div click
                          style={{ 
                            width: '22px', 
                            height: '22px',
                            cursor: 'pointer',
                            flexShrink: 0
                          }}
                        />
                        {/* Emoji removed - no longer displayed */}
                        <div className="flex-grow">
                          <div 
                            className="font-semibold flex items-center"
                            style={{ fontSize: '15px', marginBottom: '2px' }}
                          >
                            {platform.label}
                            {isSelected && (
                              <span className="ml-2 text-green-600" style={{ fontSize: '16px' }}>
                                ✓
                              </span>
                            )}
                          </div>
                          <div 
                            className="text-gray-400"
                            style={{ fontSize: '12px' }}
                          >
                            {platform.description}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Selected Platforms Chips (emoji removed from display) */}
      {selectedCount > 0 && (
        <div className="mt-3 flex flex-wrap gap-2">
          {selectedPlatforms.map((platform) => {
            return (
              <div
                key={platform.key}
                className="badge flex items-center gap-2"
                style={{
                  backgroundColor: '#f8f9fa',
                  color: '#212529',
                  border: '1px solid #dee2e6',
                  padding: '8px 14px',
                  fontSize: '14px',
                  fontWeight: 500,
                  borderRadius: '20px'
                }}
              >
                {/* Emoji removed - no longer displayed */}
                {platform.label}
                <button
                  type="button"
                  className="btn-close"
                  style={{ 
                    fontSize: '10px',
                    padding: 0,
                    width: '14px',
                    height: '14px'
                  }}
                  onClick={() => togglePlatform(platform.key)}
                  aria-label={`Remove ${platform.label}`}
                />
              </div>
            );
          })}
        </div>
      )}

      {/* Helper Text */}
      {selectedCount === 0 && (
        <div className="text-gray-400 small mt-2" style={{ fontSize: '13px' }}>
          Click the button above to select where you want to post
        </div>
      )}
    </div>
  );
}

// ========================================================================
// COMPACT INLINE VARIANT (emoji removed from display)
// ========================================================================

export function PlatformSelectorCompact({ 
  platforms, 
  setPlatforms,
  showLabels = false 
}) {
  const selectedCount = Object.values(platforms).filter(Boolean).length;

  return (
    <div className="flex flex-wrap gap-2">
      {PLATFORMS.map((platform) => {
        const isSelected = platforms[platform.key];

        return (
          <button
            key={platform.key}
            type="button"
            className={`btn ${isSelected ? 'btn-primary' : 'btn-outline-secondary'} flex items-center gap-2`}
            onClick={() => setPlatforms(prev => ({ ...prev, [platform.key]: !prev[platform.key] }))}
            title={platform.label}
            style={{
              padding: showLabels ? '8px 14px' : '8px 10px',
              fontSize: '14px'
            }}
          >
            {/* Emoji removed - no longer displayed */}
            <span>{platform.label}</span>
          </button>
        );
      })}
      
      {selectedCount > 0 && (
        <div 
          className="badge bg-gray-600 flex items-center"
          style={{ padding: '10px 12px', fontSize: '13px' }}
        >
          {selectedCount} selected
        </div>
      )}
    </div>
  );
}